import React, { useState } from 'react';
import { api } from '../services/api';
import { SignedInUser } from '../types';

interface Props {
  onSignedIn: (user: SignedInUser) => void;
}

/**
 * Prijava operatera i poslovođe.
 *
 * Postoji zbog jedne rečenice koja se ponavlja kroz ceo posao: „ko je to
 * odlučio". Ime uz potvrdu adrese, uz odluku o izuzetku i uz upis u tuđe knjige
 * dosad je bio slobodan tekst koji svako ukuca kako hoće.
 *
 * Vozač se ovde ne prijavljuje — njegov telefon radi bez mreže i bez kucanja po
 * hladnoći, pa njemu pristup ide ključem u linku.
 */
export default function SignIn({ onSignedIn }: Props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();

    setBusy(true);
    try {
      onSignedIn(await api.login(username.trim(), password));
      setError(null);
    } catch (e) {
      // Poruka namerno ne kaže da li fali ime ili lozinka.
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="signin">
      <form className="panel signin__box" onSubmit={submit}>
        <h1>Elbraco — planiranje transporta</h1>
        <p className="note">
          Ime uz svaku odluku od sada dolazi odavde, a ne iz polja na ekranu.
        </p>

        {error && <div className="health health--bad">{error}</div>}

        <label className="field">
          Korisničko ime
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />
        </label>

        <label className="field">
          Lozinka
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>

        <button type="submit" className="primary" disabled={busy}>
          {busy ? 'Prijavljujem…' : 'Prijavi se'}
        </button>
      </form>
    </div>
  );
}
